import {
  AddConfig,
  ChangesConfig,
  DeleteConfig,
  DragAndDropConfig,
  EditConfig,
  FooterConfig,
  GridApi,
  HeaderConfig,
  Icons,
  IIdentity,
  Labeling,
  RowConfig,
  SaveConfig,
  SelectionConfig,
  SequenceConfig,
  SortConfig,
  GroupConfig,
  RowGroupConfig,
  ColorConfig,
  CopyConfig,
  ImportConfig,
} from '.';

export interface GridOptions<T extends IIdentity> {
  addConfig: AddConfig<T>;
  editConfig?: EditConfig<T>;
  deleteConfig?: DeleteConfig<T>;
  copyConfig?: CopyConfig<T>;
  saveConfig?: SaveConfig<T>;
  importConfig?: ImportConfig<T>;
  rowConfig?: RowConfig<T>;
  rowGroupConfig?: RowGroupConfig<T>;
  sortConfig?: SortConfig<T>;
  dragAndDropConfig?: DragAndDropConfig<T>;
  selectionConfig?: SelectionConfig;
  sequenceConfig?: SequenceConfig;
  changesConfig?: ChangesConfig<T>;
  headerConfig?: HeaderConfig;
  footerConfig?: FooterConfig;
  labeling?: Labeling;
  icons?: Icons;
  groupConfig?: GroupConfig;
  colorConfig?: ColorConfig;
  events?: {
    onGridRegistered?: (gridApi: GridApi<T>) => void;
    onColumnHeaderSorting?: () => void;
    onSelectionSorting?: () => void;
    onDataReady?: () => void;
  };
}
